exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\ndiv[ciao-vue-dialog=\"dialog-wrap\"][data-v-2049f549] {\n  pointer-events: none;\n  position: fixed;\n  top: 0;\n  left: 0;\n  z-index: 1000;\n}\ndiv[ciao-vue-dialog=\"dialog-wrap\"][active][data-v-2049f549] {\n    pointer-events: auto;\n}\ndiv[ciao-vue-dialog=\"dialog-wrap\"] div[ciao-vue-dialog=\"overlay\"][data-v-2049f549] {\n    top: 0;\n    left: 0;\n    background-color: transparent;\n    -webkit-transition: all 0.5s ease;\n    transition: all 0.5s ease;\n    width: 300vw;\n    height: 300vh;\n}\ndiv[ciao-vue-dialog=\"dialog-wrap\"] div[ciao-vue-dialog=\"overlay\"][active][data-v-2049f549] {\n      background-color: rgba(0, 0, 0, 0.5);\n      -webkit-transition: all 0.5s ease;\n      transition: all 0.5s ease;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":false}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-2049f549","scoped":true,"hasInlineConfig":true}!./node_modules/sass-loader/lib/loader.js?{"indentedSyntax":true,"sourceMap":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=1!./src/Components/Main.vue
// module id = DyDO
// module chunks = 1